export default __webpack_public_path__ + "static/media/contact.bc3d7b99.svg";